/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ArrowLeftRight = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M16.6344 3.14815L17.6574 2.0498L21.5469 5.93936C22.1327 6.52515 22.1327 7.47489 21.5469 8.06068L17.6574 11.9502L16.6344 10.8519L19.7363 7.75003H4V6.25003H19.7363L16.6344 3.14815Z"
                        fill={color}
                    />
                    <path
                        d="M7.35187 13.1784L6.3289 12.08L2.43934 15.9696C1.85355 16.5554 1.85355 17.5051 2.43934 18.0909L6.3289 21.9805L7.35187 20.8821L4.25001 17.7803H20V16.2803H4.24999L7.35187 13.1784Z"
                        fill={color}
                    />
                </svg>
        );
    };
